/**
 * Which AI calls a Context entry is read into (SPEC.md §8.13): all of them, or only those about one
 * area or project. The value uses the destination picker's strings (`""`, `area:<id>`,
 * `project:<id>`) so `destinationToIds` reads both.
 */

import type { Area, Project } from "../api";

export function ContextScopePicker({
  value,
  areas,
  projects,
  onChange,
}: {
  value: string;
  areas: Area[];
  projects: Project[];
  onChange: (value: string) => void;
}) {
  return (
    <select
      className="input"
      style={{ flex: "1 1 10rem", minWidth: 0 }}
      aria-label="Context applies to"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Everything - every AI request</option>
      {areas.length > 0 && (
        <optgroup label="Only for this area">
          {areas.map((area) => (
            <option key={area.id} value={`area:${area.id}`}>
              {area.name}
            </option>
          ))}
        </optgroup>
      )}
      {projects.length > 0 && (
        <optgroup label="Only for this project">
          {[...projects]
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "accent" }))
            .map((project) => (
              <option key={project.id} value={`project:${project.id}`}>
                {project.name}
              </option>
            ))}
        </optgroup>
      )}
    </select>
  );
}
